import { supabase } from "@/integrations/supabase/client";
import type { CallType } from "./types";

export async function logCallHistory(params: {
  callerId: string;
  receiverId: string;
  conversationId: string;
  callType: CallType;
  status: string;
  durationSeconds?: number;
}) {
  return supabase.from("call_history").insert({
    caller_id: params.callerId,
    receiver_id: params.receiverId,
    conversation_id: params.conversationId,
    call_type: params.callType,
    status: params.status,
    duration_seconds: params.durationSeconds ?? 0,
  });
}

export async function notifyMissedCall(params: {
  userId: string;
  callerName: string;
  callType: CallType;
  title?: string;
}) {
  return supabase.from("notifications").insert({
    user_id: params.userId,
    title: params.title ?? "Missed Call",
    message: `You missed a ${params.callType} call from ${params.callerName}`,
    type: "missed_call",
  });
}
